import React from 'react';
import NextArrow from '../../assets/images/arrow_right.svg';

const SliderNextArrow = (props) => {
    const {  onClick } = props;

    return (
        <div
            className={`slick-arrow next-arrow`}
            onClick={onClick}
        >
            <img src={NextArrow} className="img-fluid" alt="slickNextArrow" />
        </div>
    );
};

export default SliderNextArrow;
